import React from 'react'

const SelectInput = React.forwardRef((props, ref) => (
  <select name='drop-category' {...props} ref={ref}>
    onChange={props.onChange}
    {(props.refund_enabled ? ['cancellation', 'game_credit', 'refund'] : ['cancellation', 'game_credit'])
      .map((o, i) => {
        return <option key={i} value={o}>{o.replace('_', ' ')}</option>
      })
    }
  </select>
))

export default SelectInput
